import { gql } from '@apollo/client';


export const INCIDENT_AUTO_SUGGEST = gql`
  query incidentAutoSuggest($incidentNumber: String!, $count: Int!, $originatorId: ID!){
    incidentAutoSuggest(incidentNumber: $incidentNumber, count: $count, originatorId: $originatorId) {
      id
      incidentNumber
      sealed
      locked
    }
  }
`;